class EmailValidator {
  private regex: RegExp;

  constructor(regex?: RegExp) {
    const defaultRegex = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    this.regex = regex || defaultRegex;
  }

  public isValid(email: string): boolean {
    return this.regex.test(email);
  }
}

export default EmailValidator;
